import type { SuggestOccupationDetail } from '../types/personShow';

export const MANAGER_OCCUPATION_DETAIL_IDS = [144, 145];
export const MANAGER_OCCUPATION_VALIDATION_MESSAGE =
  '店長・副店長を選択する場合は、店長・副店長以外の販売職種（小カテゴリー）を1つ以上選択してください。';

export const requiresAdditionalSalesDetail = (
  selectedSalesDetailIds: Array<number | string>,
): boolean => {
  const selectedIds = selectedSalesDetailIds.map(Number);
  const managerSelected = MANAGER_OCCUPATION_DETAIL_IDS.some((id) => selectedIds.includes(id));
  const otherSalesDetailSelected = selectedIds.some(
    (id) => !MANAGER_OCCUPATION_DETAIL_IDS.includes(id),
  );

  return managerSelected && !otherSalesDetailSelected;
};

export const requiresSalesDetailWithManager = (
  selectedDetailIds: Array<number | string>,
  suggestOccupationDetails: SuggestOccupationDetail[],
): boolean => {
  const selectedIds = selectedDetailIds.map(Number);
  const salesDetailIds = suggestOccupationDetails
    .find(({ occupationId }) => occupationId === 10)
    ?.occupationDetails
    .map(({ id }) => id) ?? [];
  const selectedSalesDetailIds = selectedIds.filter((id) => salesDetailIds.includes(id));

  return requiresAdditionalSalesDetail(selectedSalesDetailIds);
};

export const sortManagerOccupationDetailsFirst = <T extends { id: number }>(
  occupationDetails: T[],
): T[] => {
  return [...occupationDetails].sort((first, second) => {
    const firstPriority = MANAGER_OCCUPATION_DETAIL_IDS.indexOf(first.id);
    const secondPriority = MANAGER_OCCUPATION_DETAIL_IDS.indexOf(second.id);

    if (firstPriority === -1 && secondPriority === -1) return 0;
    if (firstPriority === -1) return 1;
    if (secondPriority === -1) return -1;
    return firstPriority - secondPriority;
  });
};
